<template>
  <div class="intro-container">
    <h1 class="intro-title">실시간 운세란?</h1>
    <p class="intro-description">
      주역의 철학적 지혜를 기반으로 보는 운세 서비스입니다. 버튼을 누른 순간의
      기운에 따라 괘(卦)와 괘의 효(爻) 하나를 뽑습니다. 그 괘와 효가 가진 의미로
      당신의 하루 운세를 풀어줍니다. 가르침을 따르면 운이 내게로 옵니다! ({{
        LYD
      }}LYD 필요)
    </p>
    <div class="intro-options">
      <input type="checkbox" id="skipIntro" v-model="skipNext" />
      <label for="skipIntro">다음부터 이 화면 건너뛰기</label>
    </div>
    <div class="intro-actions">
      <button @click="proceed">이용하기</button>
      <button @click="cancel">돌아가기</button>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue'
  import { useRouter } from 'vue-router'

  const LYD = ref(import.meta.env.VITE_CHARGE_HEXAGRAM)
  const router = useRouter()
  const skipNext = ref(false)
  const storageKey = 'skipIntroHexagram'
  const proceedTo = '/HexagramToday'

  const proceed = () => {
    if (skipNext.value) {
      localStorage.setItem(storageKey, 'true')
    }
    router.replace(proceedTo)
  }

  const cancel = () => {
    // Optionally navigate back or to a different page on cancel
    router.go(-1) // Example: go back to the previous page
  }

  onMounted(() => {
    if (localStorage.getItem(storageKey) === 'true') {
      router.replace(proceedTo)
    }
  })
</script>

<style scoped>
  .intro-container {
    min-height: 100vh;
    width: var(--device-width);
    max-width: 480px;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1.2rem;
    box-sizing: border-box;
    text-align: center;
  }

  .intro-title {
    font-size: var(--font-size-16);
    font-weight: bold;
    margin-bottom: 1.5rem;
  }

  .intro-description {
    font-size: var(--font-size-11);
    line-height: 1.6;
    margin-bottom: 2rem;
    width: 90%;
  }

  .intro-options {
    margin-bottom: 2rem;
  }

  .intro-options label {
    margin-left: 0.5rem;
  }

  .intro-actions {
    display: flex;
    gap: 1rem;
  }

  button {
    padding: 0.7rem 1.5rem;
    font-size: var(--font-size-10);
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  button:first-child {
    background-color: #4caf50; /* Green */
    color: white;
  }

  button:first-child:hover {
    background-color: #45a049;
  }

  button:last-child {
    background-color: #f44336; /* Red */
    color: white;
  }

  button:last-child:hover {
    background-color: #da190b;
  }
</style>
